<template>
  <div class="row">
    <v-col cols="12" sm="6" lg="3" v-for="stat in stats" v-bind:key="stat.id">
      <base-material-stats-card
        :color="stat.color"
        :icon="stat.icon"
        :title="stat.title"
        :value="stat.value"
        :sub-icon="stat.footerIcon"
        :sub-text="stat.footerText"
        :sub-link="stat.footerLink"
        :sub-content="stat.footerContent"
      />
    </v-col>
  </div>
</template>

<script>
export default {
  name: "get-user-stats",

  data() {
    return {
      stats: [],
    };
  },
  mounted() {
    let _ = this;

    // Statistiche utente
    this.chiamataAxios("GET", "/auth/portal/getMyStats").then((response) => {
      _._data.stats = response.data.stats;
    });
  },
};
</script>
